'use strict';
import 'babel-polyfill';

import React, {Component, PropTypes} from 'react';
import Select from 'react-select';
import {findDOMNode} from 'react-dom';
import '../public/css/form.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import JQuery from 'jquery';
import Globalize from 'globalize';

import ErrorBox from './errorBox.js';
import ErrorWrapper from './errorWrapper.js';
import {FormatMessage} from 'react-globalize';

class BfgAgentForm extends Component {


    constructor(props) {
        super(props);

        this.state = {
            agentFormNameUser: '',
            agentFormLastNameUser: '',
            agentFormEmailUser: '',
            agentFormBussines: '',
            agentFormOtherwitdBussines: '',
            agentFormPhone: '',
            agentFormAddress: '',
            agentFormStateSelected: '',
            agentFormCitySelected: '',
            agentFormBussinesTypeSelected: '',
            agentFormZipCode: '',
            infoMessage: '',
            errorlist: {},
            data: [],
            cities: [],
            bussinesType: [],

        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.updateState = this.updateState.bind(this);
        this.updateCity = this.updateCity.bind(this);
        this.updateBussinesType = this.updateBussinesType.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleKey = this.handleKey.bind(this);
    }

    render() {
        var states = this.state.data;
        var cities = this.state.cities;
        var bussinesType = this.state.bussinesType;
        return (
            <div className="col-md-10 col-md-offset-1">
                <form className="sendMoney-form" id="agentForm" onSubmit={this.handleSubmit}>
                    <header><FormatMessage locale={this.props.locale} path="agentPage/agentPageForm"/></header>
                    <fieldset>
                        <div className="col-md-8 col-md-offset-2">
                            <span className="text-info text-center">{this.props.message}</span>
                            <ErrorBox errorlist={this.state.errorlist} locale={this.props.locale}/>
                        </div>
                        <div className="col-md-8 col-md-offset-2">
                            <div className="form-group has-feedback">
                                <ErrorWrapper errorlist={this.state.errorlist} identifier="agentFormNameUser">
                                    <label className="input">
                                        <i className="icon-prepend fa fa-user"></i>
                                        <input ref="agentFormNameUser" type="text" id="agentFormNameUser"
                                               placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormName')()}
                                               value={this.state.agentFormNameUser || ''}
                                               onChange={this.handleChangeName.bind(this)} className="form-control"
                                               min="5" max="40" onBlur={this.handleValidation('agentFormNameUser')}/>
                                    </label>
                                </ErrorWrapper>
                            </div>
                            <div className="margin-bottom-10"></div>


                            <ErrorWrapper errorlist={this.state.errorlist} identifier="agentFormLastNameUser">
                                <label className="input">
                                    <i className="icon-prepend fa fa-user"></i>
                                    <input ref="agentFormLastNameUser" type="text" id="agentFormLastNameUser"
                                           placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormLastName')()}
                                           value={this.state.agentFormLastNameUser || ''}
                                           onChange={this.handleChangeLastName.bind(this)} className="form-control"
                                           min="5" max="40" onBlur={this.handleValidation('agentFormLastNameUser')}/>
                                </label>
                            </ErrorWrapper>

                            <div className="margin-bottom-10"></div>
                            <ErrorWrapper errorlist={this.state.errorlist} identifier="agentFormBussines">
                                <label className="input">
                                    <i className="icon-prepend fa fa-bank"></i>
                                    <input ref="agentFormBussines" id="agentFormBussines" type="text"
                                           placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormBussinessName')()}
                                           value={this.state.agentFormBussines || ''}
                                           onChange={this.handleChangeBussiness.bind(this)} className="form-control"
                                           onBlur={this.handleValidation('agentFormBussines')}/>
                                </label>
                            </ErrorWrapper>
                            <div className="margin-bottom-10"></div>
                            <ErrorWrapper errorlist={this.state.errorlist} identifier="agentFormBussinesTypeSelected">
                                <Select ref="agentFormBussinesTypeSelected" id="agentFormBussinesTypeSelected"
                                        options={bussinesType} simpleValue name="agentFormBussinesTypeSelected"
                                        value={this.state.agentFormBussinesTypeSelected}
                                        onChange={this.updateBussinesType}
                                        placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormBussinesType')()}
                                        clearable={false} searchable={false}/>
                            </ErrorWrapper>
                            <div className="margin-bottom-10"></div>
                            <div className="otherBussinesType">
                                <ErrorWrapper errorlist={this.state.errorlist} identifier="agentFormOtherBussines">
                                    <label className="input">
                                        <i className="icon-prepend fa fa-bank"></i>
                                        <input ref="agentFormOtherBussines" id="agentFormOtherBussines" type="text"
                                               placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormOtherBussines')()}
                                               value={this.state.agentFormOtherBussines || ''}
                                               onChange={this.handleOtherBussines.bind(this)} className="form-control"
                                               onBlur={this.handleValidation('agentFormOtherBussines')}/>
                                    </label>
                                </ErrorWrapper>
                            </div>
                            <div className="margin-bottom-10"></div>
                            <ErrorWrapper errorlist={this.state.errorlist} identifier="agentFormEmailUser">
                                <label className="input">
                                    <i className="icon-prepend fa fa-envelope-o"></i>
                                    <input ref="agentFormEmailUser" id="agentFormEmailUser" type="email"
                                           placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormEmail')()}
                                           value={this.state.agentFormEmailUser || ''}
                                           onChange={this.handleChangeEmail.bind(this)} className="form-control"
                                           onBlur={this.handleValidation('agentFormEmailUser')}/>
                                </label>
                            </ErrorWrapper>
                            <div className="margin-bottom-10"></div>
                            <ErrorWrapper errorlist={this.state.errorlist} identifier="agentFormPhone">
                                <label className="input">
                                    <i className="icon-prepend fa fa-phone"></i>
                                    <input ref="agentFormPhone" id="agentFormPhone"
                                           placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormPhone')()}
                                           type="tel" value={this.state.agentFormPhone || ''}
                                           onChange={this.handleChangePhone.bind(this)} className="form-control"
                                           pattern="^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$"
                                           onBlur={this.handleValidation('agentFormPhone')}/>
                                </label>
                            </ErrorWrapper>
                            <div className="margin-bottom-10"></div>
                            <ErrorWrapper errorlist={this.state.errorlist} identifier="agentFormAddress">
                                <label className="input">
                                    <i className="icon-prepend fa fa-arrow-right"></i>
                                    <input ref="agentFormAddress" id="agentFormAddress"
                                           placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormAddress')()}
                                           type="text" value={this.state.agentFormAddress || ''}
                                           onChange={this.handleChangeAddress.bind(this)} className="form-control"
                                           onBlur={this.handleValidation('agentFormAddress')}/>
                                </label>
                            </ErrorWrapper>
                            <div className="margin-bottom-10"></div>
                            <div className="row">
                                <div className="col-md-4 col-sm-4">
                                    <ErrorWrapper errorlist={this.state.errorlist} identifier="agentFormStateSelected">
                                        <Select className="width-200" ref="agentFormStateSelected"
                                                id="agentFormStateSelected" options={states} simpleValue
                                                name="agentFormStateSelected"
                                                value={this.state.agentFormStateSelected || ''}
                                                onChange={this.updateState.bind(this)}
                                                placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormState')()}
                                                clearable={false} searchable/>
                                    </ErrorWrapper>
                                </div>
                                <div className="col-md-4 col-sm-4">
                                    <ErrorWrapper errorlist={this.state.errorlist} identifier="agentFormCitySelected">
                                        <Select className="width-200" ref="agentFormCitySelected"
                                                id="agentFormCitySelected" options={cities} simpleValue
                                                name="agentFormCitySelected" disabled={this.state.disabled2}
                                                value={this.state.agentFormCitySelected || ''}
                                                onChange={this.updateCity}
                                                placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormCity')()}
                                                clearable={false} searchable/>
                                    </ErrorWrapper>
                                </div>
                                <div className="col-md-4 col-sm-4">
                                    <ErrorWrapper errorlist={this.state.errorlist} identifier="agentFormZipCode">
                                        <label className="input">
                                            <i className="icon-prepend fa fa-map-marker"></i>
                                            <input ref="agentFormZipCode" id="agentFormZipCode" maxLength={5}
                                                   type="number"
                                                   placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormZipCode')()}
                                                   value={this.state.agentFormZipCode || ''}
                                                   onChange={this.handleChangeZip.bind(this)} className="form-control"
                                                   onBlur={this.handleValidation('agentFormZipCode')}
                                                   onKeyPress={this.handleKey}/>
                                        </label>
                                    </ErrorWrapper>
                                </div>
                            </div>
                            <div className="margin-bottom-10"></div>
                            <div className="col-md-8 col-md-offset-2 text-center">
                                <div className="margin-bottom-10 "></div>
                                <button type="submit" className="btn-u" value="Post">Enviar</button>
                                {' '}
                                <button onClick={this.handleReset} className='btn-u'>Reset</button>
                                <div className="margin-bottom-10"></div>
                            </div>
                        </div>
                    </fieldset>
                </form>

            </div>
        );
    }


    handleChangeName(e) {
        e.preventDefault();
        var name = e.target.value;
        this.setState({
            agentFormNameUser: name
        });
    }

    handleChangeLastName(e) {
        e.preventDefault();
        var lastName = e.target.value;
        this.setState({
            agentFormLastNameUser: lastName
        });
    }

    handleChangeBussiness(e) {
        e.preventDefault();
        var bussinessName = e.target.value;
        this.setState({
            agentFormBussines: bussinessName
        });

    }

    handleOtherBussines(e) {
        e.preventDefault();
        var otherBussines = e.target.value;
        this.setState({
            agentFormOtherBussines: otherBussines
        });

    }

    handleChangeEmail(e) {
        e.preventDefault();
        var field = e.target.value;
        this.setState({
            agentFormEmailUser: field
        });
    }

    handleChangePhone(e) {
        e.preventDefault();
        var field = e.target.value;
        this.setState({
            agentFormPhone: field
        });
    }

    handleChangeAddress(e) {
        e.preventDefault();
        var field = e.target.value;
        this.setState({
            agentFormAddress: field
        });
    }

    handleChangeZip(e) {

        e.preventDefault();
        var field = e.target.value;
        if (field.length > 5) {
            e.preventDefault();
            return false;
        } else {
            this.setState({
                agentFormZipCode: field
            });
        }
    }

    handleKey(e) {
        var key = e.keyCode || e.charCode;

        if (!(key > 47 && key < 58)) {
            e.preventDefault();
            return false;
        }
        else {
            return true;
        }
    }


    handleValidation(field) {

        return event => {
            event.preventDefault();
            var errors = this.state.errorlist;
            var newErrors = {};
            var message = field;

            if (this.validateEmpty(event.target.value)) {
                errors[message] = message + 'Empty';
            } else {
                delete errors[message];
            }

            if (!this.isEmptyObject(errors)) {
                this.setState({
                    errorlist: errors
                });
            }
        }
    }


    getMessageField(field, type) {
        return Globalize(this.props.locale).messageFormatter("errorMessages/" + field + type);
    }

    isEmptyObject(ob) {
        for (var i in ob) {
            return false;
        }
        return true;
    }

    handleSubmit(e) {
        e.preventDefault();
        var errors = this.state.errorlist;
        var newErrors = {};
        var message = 'Empty';


        if (this.validateEmpty(this.state.agentFormNameUser)) {
            newErrors.agentFormNameUser = 'agentFormNameUser' + message;
        }

        if (this.validateEmpty(this.state.agentFormLastNameUser)) {
            newErrors.agentFormLastNameUser = 'agentFormLastNameUser' + message;
        }

        if (this.validateEmpty(this.state.agentFormBussines)) {
            newErrors.agentFormBussines = 'agentFormBussines' + message;
        }

        if (this.validateEmpty(this.state.agentFormBussinesTypeSelected)) {
            newErrors.agentFormBussinesTypeSelected = 'agentFormBussinesTypeSelected' + message;
        } else {
            if (this.state.agentFormBussinesTypeSelected == "11")

                if (this.validateEmpty(this.state.agentFormOtherBussines)) {
                    newErrors.agentFormOtherBussines = 'agentFormOtherBussines' + message;
                }

        }

        if (this.validateEmpty(this.state.agentFormEmailUser)) {
            newErrors.agentFormEmailUser = 'agentFormEmailUser' + message;
        }

        if (this.validateEmpty(this.state.agentFormPhone)) {
            newErrors.agentFormPhone = 'agentFormPhone' + message;
        }

        if (this.validateEmpty(this.state.agentFormAddress)) {
            newErrors.agentFormAddress = 'agentFormAddress' + message;
        }

        if (this.validateEmpty(this.state.agentFormStateSelected)) {

            newErrors.agentFormStateSelected = 'agentFormStateSelected' + message;
        }

        if (this.validateEmpty(this.state.agentFormCitySelected)) {
            newErrors.agentFormCitySelected = 'agentFormCitySelected' + message;
        }

        if (this.validateEmpty(this.state.agentFormZipCode)) {
            newErrors.agentFormZipCode = 'agentFormZipCode' + message;
        }


        if (!this.isEmptyObject(newErrors)) {
            this.setState({
                errorlist: newErrors
            });
            return;

        } else {

            var agentFormNameUser = this.state.agentFormNameUser.trim();
            var agentFormLastNameUser = this.state.agentFormLastNameUser.trim();
            var agentFormEmailUser = this.state.agentFormEmailUser.trim();
            var agentFormBussines = this.state.agentFormBussines.trim();
            var agentFormPhone = this.state.agentFormPhone.trim();
            var agentFormAddress = this.state.agentFormAddress.trim();
            var agentFormStateSelected = this.state.agentFormStateSelected.trim();
            var agentFormCitySelected = this.state.agentFormCitySelected.trim();
            var agentFormBussinesTypeSelected = this.state.agentFormBussinesTypeSelected.trim();
            var agentFormZipCode = this.state.agentFormZipCode.trim();

            var stateLabel;
            var cityLabel;
            var bussinesTypeLabel;

            for (var i = 0; i < this.state.data.length; i++) {
                let value = this.state.data[i].value.trim();
                if (value == agentFormStateSelected) {
                    stateLabel = this.state.data[i].label;
                    break;
                }
            }

            for (var i = 0; i < this.state.cities.length; i++) {
                let value = this.state.cities[i].value.trim();
                if (value == agentFormCitySelected) {
                    cityLabel = this.state.cities[i].label;
                    break;
                }
            }

            for (var i = 0; i < this.state.bussinesType.length; i++) {
                if (this.state.bussinesType[i].value == agentFormBussinesTypeSelected) {
                    bussinesTypeLabel = this.state.bussinesType[i].label;
                    break;
                }
            }


            var agentFormOtherBussines = '';
            if (this.state.agentFormOtherBussines != null)
                agentFormOtherBussines = this.state.agentFormOtherBussines.trim() || '';


            this.props.onAgentSubmit({
                agentFormNameUser: agentFormNameUser,
                agentFormLastNameUser: agentFormLastNameUser,
                agentFormEmailUser: agentFormEmailUser,
                agentFormBussines: agentFormBussines,
                agentFormOtherBussines: agentFormOtherBussines,
                agentFormPhone: agentFormPhone,
                agentFormAddress: agentFormAddress,
                agentFormStateSelected: agentFormStateSelected,
                agentFormCitySelected: agentFormCitySelected,
                stateLabel: stateLabel,
                cityLabel: cityLabel,
                bussinesTypeLabel: bussinesTypeLabel,
                agentFormZipCode: agentFormZipCode
            });

            this.loadStatesFromServer();

            this.setState({
                agentFormNameUser: '',
                agentFormLastNameUser: '',
                agentFormEmailUser: '',
                agentFormBussines: '',
                agentFormOtherBussines: '',
                agentFormPhone: '',
                agentFormAddress: '',
                agentFormStateSelected: '',
                agentFormCitySelected: '',
                agentFormBussinesTypeSelected: '',
                agentFormZipCode: '',
                infoMessage: this.props.message,
                errorlist: {}
            });
        }


    }

    handleReset(event) {
        event.preventDefault();

        this.setState({
            agentFormNameUser: '',
            agentFormLastNameUser: '',
            agentFormEmailUser: '',
            agentFormBussines: '',
            agentFormOtherBussines: '',
            agentFormPhone: '',
            agentFormAddress: '',
            agentFormStateSelected: '',
            agentFormCitySelected: '',
            agentFormBussinesTypeSelected: '',
            agentFormZipCode: '',
            infoMessage: '',
            errorlist: {}

        });
    }

    validateEmpty(input) {

        if (!input || input === null || input.length === 0) {
            return true;
        } else {

            return false;
        }

    }

    loadStatesFromServer() {
        $.ajax({
            url: '/api/usa_states',
            type: 'POST',
            dataType: 'json',
            cache: false,
            success: function (data) {
                this.setState({data: data});
            }.bind(this),
            error: function (xhr, status, err) {
                console.error(this.props.url, status, err.toString());
            }.bind(this)
        });
    }

    loadCitiesFromServer(idState) {
        if (idState == null)
            this.setState({cities: []});
        else
            $.ajax({
                url: '/api/usa_cities',
                type: 'POST',
                dataType: 'json',
                data: {state_iso: idState},
                cache: false,
                success: function (cities) {
                    this.setState({cities: cities});
                }.bind(this),
                error: function (xhr, status, err) {
                    console.error(this.props.url, status, err.toString());
                }.bind(this)
            });
    }

    loadBussinesTypeFromServer(localeId) {
        if (localeId == null)
            this.setState({bussinesType: []});
        else
            $.ajax({
                url: '/api/bussines_type',
                type: 'POST',
                dataType: 'json',
                data: {locale_id: localeId},
                cache: false,
                success: function (data) {
                    this.setState({bussinesType: data});
                }.bind(this),
                error: function (xhr, status, err) {
                    console.error(this.props.url, status, err.toString());
                }.bind(this)
            });
    }

    updateState(newValue) {

        if (newValue != '' && this.state.errorlist['agentFormStateSelected'] != null)
            this.deleteErrors('agentFormStateSelected');

        this.setState({
            agentFormStateSelected: newValue
        });

        this.loadCitiesFromServer(newValue);
        this.focusStateSelect();

    }

    updateCity(newValue) {

        if (newValue != '' && this.state.errorlist['agentFormCitySelected'] != null)
            this.deleteErrors('agentFormCitySelected');

        this.setState({
            agentFormCitySelected: newValue
        });
    }

    updateBussinesType(newValue) {

        if (newValue != '' && this.state.errorlist['agentFormBussinesTypeSelected'] != null)
            this.deleteErrors('agentFormBussinesTypeSelected');


        if (newValue == "11") {
            $(".otherBussinesType").show(300);
        } else {
            $(".otherBussinesType").hide(100);
        }

        this.setState({
            agentFormBussinesTypeSelected: newValue
        });
    }

    deleteErrors(errorName) {
        var errors = this.state.errorlist;
        delete errors[errorName];
        this.setState({
            errorlist: errors
        });
    }

    focusStateSelect() {
        this.refs.agentFormCitySelected.focus();
    }

    componentDidMount() {
        this.loadStatesFromServer();
        this.loadBussinesTypeFromServer(this.props.locale);

    }

    componentWillReceiveProps(nextProps) {

        if (!(this.props.locale == nextProps.locale)) {
            this.loadBussinesTypeFromServer(nextProps.locale);
        }

    }


}
;



module.exports = (BfgAgentForm);







// WEBPACK FOOTER //
// ./js/agentForm.js